// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jEtO0LLS4ZrCLbEM\\+via6g\\=\\= {\n  position: absolute;\n  bottom: 20%;\n  text-align: center;\n  width: 100%;\n  }\n", "",{"version":3,"sources":["webpack://./src/shared/styles/ChangeFile.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX","sourcesContent":[".changeFilePosition {\n  position: absolute;\n  bottom: 20%;\n  text-align: center;\n  width: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"changeFilePosition": "jEtO0LLS4ZrCLbEM+via6g=="
};
export default ___CSS_LOADER_EXPORT___;
